// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__QoM14","listBlock":"styles_listBlock__1A6Dd","selected":"styles_selected__3tQLU","footer":"styles_footer__1-wjg"};